<template>
    <div class="mt-36">
        <UiExtraNarrowContent>
            <h1 class="text-5xl">Cookie policy</h1>
        </UiExtraNarrowContent>
        <ContentBlogArticleNoTitle 
            v-for="article in blog.articles" 
            :key="article.id" 
            :article="article"
        />
    </div>

</template>

<script setup>
import { useBlogStore } from '@/stores/blogStore';
const blogStore = useBlogStore();


// Definiera props
const props = defineProps({
  blog: {
    type: Object,
    required: true
  }
});

</script>

<style scoped>

</style>

